// TermsOfServicePage.tsx
import React from 'react';
import { fadeTimeout, getOverallPadding } from '../helpers/Themes';
import { Fade } from '@mui/material';
import { User } from '../workers/ApiWorker';
import Box from '@mui/material/Box';
import PageTopSection from '../components/universal/pageTopSection/PageTopSection';
import TermsModal from '../components/modal/TermsModal';
import { TermsOfServiceContent } from '../helpers/TermsOfService';

interface TermsOfServicePageProps {
    isMobile: boolean;
    padding?: number;
    user?: User;
}

const TermsOfServicePage: React.FC<TermsOfServicePageProps> = ({
    isMobile,
    padding,
    user,
}) => {
    const closeTermsModal = () => {};

    return (
        <Fade in={true} timeout={fadeTimeout}>
            <Box sx={{ position: 'relative', overflow: 'hidden', padding: 2 }}>
                <Box
                    sx={{
                        paddingLeft: getOverallPadding(isMobile, padding),
                        paddingRight: getOverallPadding(isMobile, padding),
                    }}
                >
                    <Box
                        sx={{
                            textAlign: 'left',
                        }}
                    >
                        <TermsOfServiceContent />
                    </Box>
                </Box>
            </Box>
        </Fade>
    );
};

export default TermsOfServicePage;
